import type { PromptBinding, PromptSegment } from "@seedance/contracts";
export interface PromptBindingStatusProps {
  reference: Extract<PromptSegment, { type: "reference" }>; binding?: PromptBinding;
  hasTargetContext?: boolean; targetLabel?: string; onRebind(): void; onRemove(): void;
}
const missingLabels = {
  unbound: "待绑定", edge_removed: "连线已移除", node_removed: "素材节点已移除",
  asset_replaced: "素材已替换", legacy_unresolved: "旧引用待确认", not_copied: "素材未复制"
} as const;

export function PromptBindingStatus({ reference, binding, hasTargetContext = false, targetLabel, onRebind, onRemove }: PromptBindingStatusProps) {
  const validBinding = binding?.slotId === reference.slotId ? binding : undefined;
  const bound = hasTargetContext && validBinding?.value.state === "bound" && validBinding.value.target.kind === reference.kind;
  const status = hasTargetContext ? bound ? "已绑定" : validBinding?.value.state === "missing" ? missingLabels[validBinding.value.reason] : "待绑定" : undefined;
  return <span className={`prompt-binding-status${hasTargetContext && !bound ? " prompt-binding-status--missing" : ""}`}>
    <span>{bound ? targetLabel || reference.label : reference.label}</span>
    {status ? <span className="prompt-binding-status__state">{status}</span> : null}
    <button type="button" aria-label={`重新绑定 ${reference.label}`} onClick={onRebind}>重新绑定</button>
    <button type="button" aria-label={`移除引用 ${reference.label}`} onClick={onRemove}>×</button>
  </span>;
}
